/*
 * Copyright (c) Dito Technologies
 */

import {ACCESS_TOKEN_KEY} from "constants/keys";
import {Environment, Network, RecordSource, Store} from "relay-runtime";

const BASE_URL = "https://agora-api.anthonydito.com/gql/endpoint"

async function fetchQuery(operation: any, variables: any) {
    const headers: any = {
        "Content-Type": "application/json",
    };
    const accessToken = localStorage.getItem(ACCESS_TOKEN_KEY);
    if (accessToken) {
        headers["x-parsley-gql-access-token"] = accessToken;
    }
    const response = await fetch(BASE_URL, {
        method: "POST",
        headers: headers,
        body: JSON.stringify({
            query: operation.text,
            variables,
        }),
    });
    const resp = await response.json();
    if (!response.ok || resp.errors) {
        console.error(resp)
        throw resp;
    }
    return resp;
}

export default new Environment({
    network: Network.create(fetchQuery),
    store: new Store(new RecordSource()),
});
